import React, {useState, useEffect} from 'react'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';
import Header from './../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { Dialog, DialogTitle, Fab, TextField } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import { NavLink } from 'react-router-dom';
import Switch from '../switch/Switch';
import LinearWithValueLabel from '../linear_progress_with_label/LinearProgressWithLabel';

const FakeChatGroup = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

    const [isSending, setIsSending] = useState(false);
    const [formData, setFormData] = useState({
        chatGroupName: '',
    })
    const onChange = (event)=>{
        const { value, name } = event.target;
        setFormData(pVal => {
             if(name.toLowerCase().indexOf("file") == -1){
                  return {
                       ...pVal,
                       [name]: value
                  };
             }
             else{
                  return {
                       ...pVal,
                       [name]: event.target.files[0]
                  };
             }
        });
        // console.log(formData);
   }

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [isCreateDialogOpen, setCreateDialogOpen] = useState(false);
     const [errorMessage, setErrorMessage] = useState(null);
     const tableHead = ["Group Id", "Group Name", ""];

     const onPageChange = async (e, pageIndex) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);

               const res = await axiosInstance.get('admin/fake-chat-group-list', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

    const onSubmit = async ()=>{

        if(!formData.chatGroupName){
             Toast.error('Please enter chat group name');
             return;
        }

        setIsSending(true)
        try {
             const rBody = new FormData();
             rBody.append('chatGroupName', formData.chatGroupName);
             const res = await axiosInstance.post("admin/fake-chat-group", rBody, 
                  {
                       headers: { "Content-Type": "multipart/form-data" },
                  }
             );
             setFormData({
                chatGroupName: '',
             })
             setCreateDialogOpen(false);
             Toast.success('Created');
             setIsSending(false);
        } catch (error) {
             console.log(error);
             setIsSending(false);
             Toast.error('Failed.')
             setFormData({
                chatGroupName: '',
           })
        }
    }

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Fake Chat Group</h5>
                    </div>
                    <div className="d-flex align-items-center">
                         <div className='banner_create' onClick={()=> setCreateDialogOpen(true)}>
                              <AddRounded style={{color: '#fff'}}/>
                              <button>Create</button>
                         </div>
                    </div>
                    {/* <DropdownMenu items={["Active users", "Blocked users"]} onChange={(value, i)=> {
                              const status = i == 0 ? "active" : "blocked";
                              setUserAccountStatus(status);
                              onPageChange(null, 0, status);
                         }}/> */}
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
               <Dialog
                open={isCreateDialogOpen}
                onClose={isSending?()=>{}:(b)=>setCreateDialogOpen(false)}>

                    <DialogTitle style={{width: "400px"}}>Create Fake Chat Group</DialogTitle>
                                <div>
                                   <TextField name='chatGroupName' value={formData.chatGroupName} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '40px', color: 'red'}} fullWidth label="Chat Group Name" type="text" inputProps={{ maxLength: 80 }}/>
                              </div>
                              <button onClick={onSubmit} style={{width: '90%', marginLeft: "20px", marginBottom: '20px', marginTop: '30px', cursor: isSending ? "progress" : 'pointer'}} className="__btn">Create</button>
                </Dialog>
          </>
     );
}

const Item = (props) => {
     const { _id, name, date } = props.data;

     const [isDelete, setDelete] = useState(false);

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onDelete = async () => {
          setDelete(true);
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               const res = await axiosInstance.post("admin/fake-chat-group-delete", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setDelete(false);
          }
     }

     if(isDelete) return null;

     return(
          <tr>
               <td>{_id}</td>
               <td>{name}</td>
               <td><button onClick={()=> naviagte("/admin-fake-chat" + "?chatGroupId=" + _id)} style={{background: "green", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >View Chat</button></td>
               <td><button onClick={onDelete} style={{background: "red", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Delete Group</button></td>
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default FakeChatGroup;